'use strict';

import _ from 'lodash';

export default function() {
  return {
    controller: function($scope, $http, $sce) {
      'ngInject';

      $scope.page = 0;


      function _getLogos() {
        $http({
          url: '/api/testimonial/' + ($scope.element.data.imageOnly ? 'getcompanies' : 'gettestimonials'),
          method: 'get',
          params: { tag: $scope.element.data.tag, includeCompany: true}
        })
          .then(function Success(result) {
            $scope.testimonials = result.data;
          }, function Fail(result) {
            console.log("Get Testimonials Failed: " + result);
          })
      }

      _getLogos();
      //$scope.$watch("element.data.gray", _getLogos);

    },
    template: require('./testimonialimagefeature.html')
  };
};



// WEBPACK FOOTER //
// ./sgcontenteditor/customElements/testimonialimagefeature.js